module.exports = __webpack_public_path__ + "assets/img/teacher (6).8890aa7e.png";